
import Vue from "vue";

export default Vue.extend({
  name: "component-box-button",
  props: {
    imgHeight: {
      type: Number,
      default: 40,
    },
    imgWidth: {
      type: Number,
      default: 40,
    },
    imgSrc: String,
    displayText: String,
    dataName: String,
  },
  computed: {
    arrowIcon(): string {
      return require("@/assets/images/top/top-btn-arrow.svg");
    },
    systemLocaleEn(): boolean {
      return this.$i18n.locale.includes("en");
    },
  },
  methods: {
    btnClicked() {
      this.$emit("click", this.dataName);
    },
  },
});
